<template>
  <div class="container">
    <!--头图-->
    <div class="main-top"
         id="top">
      <img src="https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-top.png"
           class="m-banner"
           alt="头部图片" />
      <img src="https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-top.png"
           class="pc-banner"
           alt="头部图片" />
    </div>
    <div class="bottom-content">
      <!--底部背景-->
      <div class="pc-bg">
        <div class="left1"></div>
        <div class="left2"></div>
        <div class="right1"></div>
        <div class="right2"></div>
      </div>
      <div class="main">
        <!--复工领豪礼-->
        <big-gift></big-gift>
        <!-- 车型亮点 -->
        <bright-points></bright-points>
        <!-- 车型评测 -->
        <evaluate></evaluate>
        <!-- 精美图赏 -->
        <enjoy-img></enjoy-img>
        <!-- 精彩视频 -->
        <look-video></look-video>
        <!--相关资讯-->
        <related-information></related-information>
      </div>
    </div>
  </div>
</template>

<script>
import BigGift from '../components/BigGift'
import BrightPoints from '../components/BrightPoints'
import Evaluate from '../components/Evaluate'
import EnjoyImg from '../components/EnjoyImg'
import LookVideo from '../components/LookVideo'
import RelatedInformation from '../components/RelatedInformation'
export default {
  name: 'Home',
  components: {
    BigGift,
    BrightPoints,
    Evaluate,
    EnjoyImg,
    LookVideo,
    RelatedInformation
  },
  data: () => ({}),
  created () {
    // 微信分享
    this.wxsharePage()
    // app分享
    this.appShareBtn()
  },
  methods: {
  }
}
</script>

<style lang="less">
.container {
  width: 100%;
  background: #290909;
}
.main-top {
  background: #290909;
  width: 100%;
  img {
    width: 100%;
    background: #290909;
    position: relative;
  }
  .m-banner {
    display: block;
  }
  .pc-banner {
    display: none;
  }
}
@media screen and (min-width: 751px) {
  .main-top {
    .pc-banner {
      display: block;
    }
    .m-banner {
      display: none;
    }
  }
  .bottom-content {
    position: relative;
  }
  .main {
    width: 1000px;
    margin: 0 auto;
  }
  .pc-bg {
    display: block;
    .left1 {
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/bg-left1.png");
      background-size: cover;
      width: 502px;
      height: 517px;
      position: absolute;
      top: 404px;
      left: 0;
    }
    .left2 {
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/bg-left2.png");
      background-size: cover;
      width: 453px;
      height: 618px;
      position: absolute;
      top: 2663px;
      left: 0;
    }
    .right1 {
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/bg-right1.png");
      background-size: cover;
      width: 432px;
      height: 498px;
      position: absolute;
      top: 1658px;
      right: 0;
    }
    .right2 {
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/bg-right2.png");
      background-size: cover;
      width: 456px;
      height: 723px;
      position: absolute;
      top: 4048px;
      right: 0;
    }
  }
}
</style>
